export const ROOM_META_KEYS = ['roomId', 'room', 'roomName'] as const;

export type RoomMetaKey = (typeof ROOM_META_KEYS)[number];

export type RoomMeta = Partial<Record<RoomMetaKey, string>>;

function asRecord(raw: unknown): Record<string, unknown> | null {
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return null;
  return raw as Record<string, unknown>;
}

/** 跟 Worker `allowRoomMeta` 同一組鍵。缺欄回 undefined，好讓舊推送留著上一則的房間。 */
export function readRoomMeta(raw: unknown): RoomMeta | undefined {
  const source = asRecord(raw);
  if (!source) return undefined;
  const out: RoomMeta = {};
  for (const key of ROOM_META_KEYS) {
    const value = source[key];
    if (typeof value !== 'string') continue;
    const trimmed = value.trim();
    if (trimmed === '') continue;
    out[key] = trimmed;
  }
  return out;
}
